module.exports = __webpack_public_path__ + "static/media/neou_signin.f66be7fa.png";